import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { pushAction } from './push';

export default function PushStatus() {
  const [status, setStatus] = useState('Подключаем уведомления…');
  const available = Boolean(window.ProkatPush);
  useEffect(() => {
    if (!available) return undefined;
    const bridge = window.ProkatPush;
    bridge.onmessage = event => {
      try { setStatus(JSON.parse(event.data).status); } catch { /* Ignore invalid native replies. */ }
    };
    const refresh = () => { if (!window.prokatProstAppPaused) pushAction('status'); };
    refresh();
    const timer = setInterval(refresh, 5000);
    return () => { clearInterval(timer); bridge.onmessage = null; };
  }, [available]);
  if (!available) return null;
  return <div style={{ padding: '8px 16px', fontSize: 12 }} aria-live="polite">
    <span>{status}</span>{' '}<Button size="small" onClick={() => pushAction('enable')}>Настроить уведомления</Button>
  </div>;
}
